// extracted by mini-css-extract-plugin
export var collectionCard = "_redotech-redo-web-src-faq-customer-portal-home-collection-card";
export var header = "_redotech-redo-web-src-faq-customer-portal-home-header";
export var headerContent = "_redotech-redo-web-src-faq-customer-portal-home-header-content";
export var headline = "_redotech-redo-web-src-faq-customer-portal-home-headline";
export var mobileBackButton = "_redotech-redo-web-src-faq-customer-portal-home-mobile-back-button";
export var pageContent = "_redotech-redo-web-src-faq-customer-portal-home-page-content";